<template>
		<div class="flex-1">
			<div v-if="!isempty" style="min-height: 300px;padding: 5px 4%; margin-top: 10px;" v-loading="isLoading">
				<div class="rich-text line-break" v-html="data.content || ''"></div>
				
				<!-- 复制文案 -->
				<div v-if="data.content" class="copy-text" @click="copy">
					点击复制文本内容到剪贴板
				</div>
				<div v-if="fileList.length==1" class="image-grid">
					<!--加载图片-->
					<el-image 
						v-for="(item,index) in fileList" 
						:key="index" 
						class="square-image1"
						:src="item" 
						:preview-src-list="fileList"
						fit="cover">
					</el-image>
				</div>
				<div v-if="fileList.length>1" class="image-grid">
					<!--加载图片-->
					<el-image 
						v-for="(item,index) in fileList" 
						:key="index" 
						class="square-image"
						:src="item" 
						:preview-src-list="fileList"
						fit="cover">
					</el-image>
				</div>
			</div>
			<div v-if="isempty">
				<el-empty description="素材链接已过期" :image-size="120"></el-empty>
			</div>
		</div>
</template>

<script>
import { EventBus } from '@/main.js'
export default {
	name: 'Targeted',
	data(){
		return{
			kkey:this.$route.query.kkey,
			data:[],
			fileList:[],
			isempty: false,
		}
	},
	mounted(){
		this.setViewportMeta();
		// 2. 监听触摸事件，阻止双指缩放
		this.preventZoom();

		this.getData(this.kkey);
	},
	methods: {
		// 设置viewport元标签
		setViewportMeta() {
			let meta = document.querySelector('meta[name="viewport"]')
			if (meta) {
				meta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no'
			} else {
				meta = document.createElement('meta')
				meta.name = 'viewport'
				meta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no'
				document.head.appendChild(meta)
			}
		},
		// 阻止双指缩放事件
		preventZoom() {
			// 阻止触摸缩放
			this.preventTouchZoom = (e) => {
				if (e.touches.length > 1) {
					e.preventDefault()
				}
			}
			window.addEventListener('touchmove', this.preventTouchZoom, { passive: false })
			
			// 阻止双击缩放（部分浏览器）
			let lastTouchEnd = 0
			document.addEventListener('touchend', (e) => {
				const now = Date.now()
				if (now - lastTouchEnd <= 300) {
					e.preventDefault()
				}
				lastTouchEnd = now
			}, false)
		},
		copy(){
			this.$copyText(this.data.content).then(e => {
				this.$message.success('复制文案成功')
			}, function (e) {
				this.$message.error('复制文案失败')
			})
		},
		async getData(kkey){
			let params = {
				kkey: kkey,
			}
			this.$http.get('/api/webs/search/getCacheSysMoment', { params })
			.then(response => {
				if(response.code=='B000004'){
					this.isempty=true;
				} else {
					let res = response.data
					this.isLoading = false
					if(res != null){
						this.data = res
						this.fileList = JSON.parse(res.file)
						document.title = res.title;
					}
				}
			})
			.catch(error => {
				console.error(error)
				this.isLoading = false
			})
		},
		goBack(){
			this.$router.go(-1)
		}
	}
}
</script>

<style>
	/* 全局禁止缩放/选择样式 */
html, body {
  touch-action: manipulation; /* 禁用双击缩放，仅允许平移/点击 */
  user-scalable: no; /* 兼容老浏览器 */
  -webkit-user-scalable: no; /* 兼容iOS Safari */
  -ms-user-scalable: no; /* 兼容IE/Edge */
  user-select: none; /* 禁止文本选择（可选） */
  -webkit-user-select: none;
}
.share{
	width: 30px;
}
.el-descriptions-item__label.is-bordered-label{
	width: 140px !important;
}
/* 图片网格布局：实现3列换行 + 均匀间距 */
.image-grid {
  display: flex;          /* 弹性布局 */
  flex-wrap: wrap;        /* 自动换行（核心：实现3个一行） */
  gap: 15px;              /* 图片之间的间距（替代margin，更简洁） */
  margin: 10px 0;         /* 上下外边距 */
}

/* 正方形图片核心样式：3列均分 */
.square-image {
  width: calc(33.333% - 10px); /* 3列 - 间距补偿（gap=15px，每列减去10px） */
  aspect-ratio: 1 / 1;    /* 宽高1:1，正方形 */
  box-sizing: border-box; /* 避免padding/border影响宽度 */
}
.square-image1{
	width:100%;
}
/* 强制el-image内部容器填满正方形 */
.square-image >>> .el-image__inner {
  width: 100% !important;
  height: 100% !important;
}

/* 关键：解析\n为换行 */
.line-break {
  white-space: pre-line; 
  /* 可选：补充行高，提升可读性 */
  line-height: 1.8;
  font-size: 16px;
}

.copy-text{
	margin: 15px 0;
    font-size: 16px;
    color: #409eff;
    cursor: pointer;
    text-decoration: underline;
    transition: color .2s;
}
</style>